import { useTranslations } from 'next-intl'

export const Clone1Placeholder = () => {
	const t = useTranslations()
	const placeholderDescription = t(
		'generator__phone_preview__placeholder_description',
	)

	return (
		<svg
			width="220"
			height="312"
			viewBox="0 0 220 312"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="absolute left-1/2 top-[74px] -translate-x-1/2 overflow-visible"
		>
			<g clipPath="url(#clip0_32164_15789)">
				<path
					d="M116.667 198.667V192H110V185.333H116.667V192H123.333V185.333V178.667V172H116.667V178.667H110H103.333V172H110H116.667V165.333V158.667H110V165.333H103.333V158.667H96.6667V165.333V172V178.667H90H83.3334V185.333V192V198.667H90V192V185.333H96.6667H103.333V192V198.667H110V205.333H116.667V212H123.333V205.333H130V198.667H123.333H116.667Z"
					fill="#79809A"
				/>
				<path
					d="M90 198.667V205.333H96.6667H103.333V198.667H96.6667H90Z"
					fill="#79809A"
				/>
				<path
					d="M150 185.333V178.667H143.333V185.333H136.667V192H130V198.667H136.667V205.333H143.333H150V198.667H143.333V192H150H156.667V185.333H150Z"
					fill="#79809A"
				/>
				<path
					d="M163.333 178.667H156.667V185.333H163.333V178.667Z"
					fill="#79809A"
				/>
				<path d="M156.667 172H150V178.667H156.667V172Z" fill="#79809A" />
				<path
					d="M143.333 178.667V172H136.667H130V178.667V185.333H136.667V178.667H143.333Z"
					fill="#79809A"
				/>
				<path d="M70 172V165.333H63.3334V172V178.667H70V172Z" fill="#79809A" />
				<path
					d="M56.6667 178.667V172V165.333H50V172H43.3334V178.667H50H56.6667Z"
					fill="#79809A"
				/>
				<path d="M36.6667 172H30V178.667H36.6667V172Z" fill="#79809A" />
				<path
					d="M90 172V165.333V158.667H96.6667V152H90H83.3333V145.333H76.6667H70V152H76.6667V158.667H83.3333V165.333H76.6667V172V178.667H83.3333V172H90Z"
					fill="#79809A"
				/>
				<path d="M36.6667 158.667H30V165.333H36.6667V158.667Z" fill="#79809A" />
				<path
					d="M156.667 145.333V138.667H150H143.333V145.333H150V152H143.333H136.667V158.667H143.333V165.333H150V158.667H156.667V165.333H163.333V158.667V152H156.667V145.333Z"
					fill="#79809A"
				/>
				<path
					d="M130 145.333H123.333V152V158.667V165.333H130V158.667V152H136.667V145.333H130Z"
					fill="#79809A"
				/>
				<path
					d="M110 152V145.333H103.333V138.667H96.6666V145.333V152H103.333H110Z"
					fill="#79809A"
				/>
				<path
					d="M116.667 138.667H123.333V132H116.667H110V138.667V145.333H116.667V138.667Z"
					fill="#79809A"
				/>
				<path
					d="M76.6666 138.667H83.3333V145.333H90V138.667V132H83.3333V125.333H76.6666V132H70H63.3333V125.333H56.6666V132V138.667H63.3333V145.333H70V138.667H76.6666Z"
					fill="#79809A"
				/>
				<path
					d="M50 132H43.3333V138.667H36.6667V145.333H30V152H36.6667V158.667H43.3333V152V145.333H50V152V158.667H56.6667H63.3333V152H56.6667V145.333V138.667H50V132Z"
					fill="#79809A"
				/>
				<path
					d="M163.333 125.333H156.667V132H163.333V125.333Z"
					fill="#79809A"
				/>
				<path
					d="M143.333 125.333H136.667V132H130V138.667H136.667H143.333V132V125.333Z"
					fill="#79809A"
				/>
				<path
					d="M103.333 125.333H96.6666V132H103.333V125.333Z"
					fill="#79809A"
				/>
				<path d="M36.6667 125.333H30V132H36.6667V125.333Z" fill="#79809A" />
				<path
					d="M130 118.667V112H123.333V118.667V125.333H130H136.667V118.667H130Z"
					fill="#79809A"
				/>
				<path
					d="M103.333 118.667V125.333H110H116.667V118.667V112V105.333V98.6665H110V105.333H103.333V112H110V118.667H103.333Z"
					fill="#79809A"
				/>
				<path
					d="M90 118.667H96.6667V112H90H83.3334V118.667V125.333H90V118.667Z"
					fill="#79809A"
				/>
				<path d="M136.667 105.333H130V112H136.667V105.333Z" fill="#79809A" />
				<path
					d="M90 105.333H96.6667V98.6668H103.333V92.0002H110V85.3335H103.333H96.6667V92.0002H90V85.3335H83.3334V92.0002V98.6668H90V105.333Z"
					fill="#79809A"
				/>
				<path
					d="M130 92.0002H136.667V85.3335H130H123.333H116.667V92.0002H123.333V98.6668V105.333H130V98.6668V92.0002Z"
					fill="#79809A"
				/>
				<path
					d="M170 205.333V198.667H163.333V192H156.667V198.667V205.333V212H163.333V205.333H170Z"
					fill="#79809A"
				/>
				<path
					d="M163.333 138.667V145.333V152H170V158.667H163.333V165.333H170H176.667V158.667V152V145.333H170V138.667V132H163.333V138.667Z"
					fill="#79809A"
				/>
				<path
					d="M170 185.333H176.667V178.667V172H170H163.333V178.667H170V185.333Z"
					fill="#79809A"
				/>
				<path d="M176.667 125.333H170V132H176.667V125.333Z" fill="#79809A" />
				<path d="M150 212H143.333V218.667H150V212Z" fill="#79809A" />
				<path d="M130 212H123.333V218.667H130V212Z" fill="#79809A" />
				<path
					d="M83.3334 218.667V225.333V232H90V225.333V218.667V212H83.3334V218.667Z"
					fill="#79809A"
				/>
				<path d="M170 212H163.333V218.667H170V212Z" fill="#79809A" />
				<path
					d="M163.333 218.667H156.667V225.333H163.333V218.667Z"
					fill="#79809A"
				/>
				<path d="M176.667 205.333H170V212H176.667V205.333Z" fill="#79809A" />
				<path
					d="M136.667 225.333V232H143.333H150V225.333H143.333V218.667H136.667V225.333Z"
					fill="#79809A"
				/>
				<path
					d="M110 218.667V212H103.333V218.667H96.6666V225.333H103.333V232H110H116.667V225.333H110V218.667Z"
					fill="#79809A"
				/>
				<path d="M130 225.333H123.333V232H130V225.333Z" fill="#79809A" />
				<path
					d="M170 232H176.667V225.333H170H163.333V232H170Z"
					fill="#79809A"
				/>
				<path d="M190 225.333H183.333V232H190V225.333Z" fill="#79809A" />
				<path
					d="M183.333 185.333H176.667V192V198.667V205.333H183.333V212H176.667V218.667H183.333H190V212V205.333V198.667H183.333V192H190V185.333V178.667H183.333V185.333Z"
					fill="#79809A"
				/>
				<path
					d="M183.333 165.333V172H190V165.333V158.667H183.333V165.333Z"
					fill="#79809A"
				/>
				<path
					d="M183.333 132H176.667V138.667H183.333V145.333V152H190V145.333V138.667V132V125.333H183.333V132Z"
					fill="#79809A"
				/>
				<path
					d="M123.333 78.6667H130V72H123.333H116.667H110V78.6667H116.667H123.333Z"
					fill="#79809A"
				/>
				<path
					d="M96.6667 78.6667V72H90H83.3334V78.6667H90V85.3333H96.6667V78.6667Z"
					fill="#79809A"
				/>
				<path
					d="M50 198.667H43.3334V205.333V212V218.667H50H56.6667H63.3334V212V205.333V198.667H56.6667H50Z"
					fill="#79809A"
				/>
				<path
					d="M63.3333 185.333H30V232H76.6667V185.333H63.3333ZM70 198.667V225.333H36.6667V192H70V198.667Z"
					fill="#79809A"
				/>
				<path
					d="M163.333 85.3335H156.667V92.0002V98.6668V105.333H163.333H170H176.667V98.6668V92.0002V85.3335H170H163.333Z"
					fill="#79809A"
				/>
				<path
					d="M183.333 72H143.333V118.667H190V72H183.333ZM183.333 85.3333V112H150V78.6667H183.333V85.3333Z"
					fill="#79809A"
				/>
				<path
					d="M56.6667 105.333H63.3334V98.6668V92.0002V85.3335H56.6667H50H43.3334V92.0002V98.6668V105.333H50H56.6667Z"
					fill="#79809A"
				/>
				<path
					d="M43.3333 118.667H76.6667V72H30V118.667H43.3333ZM36.6667 105.333V78.6667H70V112H36.6667V105.333Z"
					fill="#79809A"
				/>
				<path
					d="M86 152C86 138.745 96.7452 128 110 128C123.255 128 134 138.745 134 152C134 165.255 123.255 176 110 176C96.7452 176 86 165.255 86 152Z"
					fill="white"
				/>
				<path
					d="M118.513 143.487L119.198 143.181L119.081 142.919L118.819 142.802L118.513 143.487ZM104.6 151.923L103.939 151.568L103.448 152.484L104.471 152.662L104.6 151.923ZM110.077 157.4L109.338 157.529L109.516 158.552L110.432 158.061L110.077 157.4ZM111.68 156.276C111.308 156.094 110.859 156.248 110.676 156.62C110.494 156.992 110.648 157.442 111.02 157.624L111.35 156.95L111.68 156.276ZM113.64 161L112.9 161.123L113.1 162.331L114.085 161.603L113.64 161ZM115.661 153.85C115.44 153.499 114.977 153.395 114.627 153.616C114.277 153.837 114.172 154.3 114.393 154.65L115.027 154.25L115.661 153.85ZM104.376 151.057C104.558 151.429 105.008 151.583 105.38 151.401C105.752 151.218 105.906 150.769 105.724 150.397L105.05 150.727L104.376 151.057ZM101 148.437L100.397 147.992C100.242 148.202 100.207 148.477 100.305 148.719C100.403 148.961 100.62 149.135 100.877 149.177L101 148.437ZM107.35 147.684C107.7 147.905 108.163 147.8 108.384 147.45C108.605 147.1 108.501 146.637 108.15 146.416L107.75 147.05L107.35 147.684ZM104.548 155.442C104.841 155.149 104.841 154.674 104.548 154.381C104.256 154.088 103.781 154.088 103.488 154.381L104.018 154.911L104.548 155.442ZM103.25 158.75L102.539 158.987L102.657 159.343L103.013 159.462L103.25 158.75ZM107.619 158.513C107.912 158.22 107.912 157.745 107.619 157.452C107.327 157.159 106.852 157.159 106.559 157.452L107.089 157.982L107.619 158.513ZM118.513 143.487L118.819 142.802C115.851 141.477 109.15 141.856 103.939 151.568L104.6 151.923L105.261 152.278C110.195 143.082 116.127 143.243 118.207 144.172L118.513 143.487ZM104.6 151.923L104.471 152.662C104.877 152.732 106.215 153.202 107.507 154.493L108.037 153.963L108.567 153.433C107.065 151.931 105.45 151.31 104.729 151.184L104.6 151.923ZM118.513 143.487L117.828 143.793C118.757 145.873 118.918 151.805 109.722 156.739L110.077 157.4L110.432 158.061C120.144 152.85 120.523 146.149 119.198 143.181L118.513 143.487ZM110.077 157.4L110.816 157.272C110.69 156.55 110.069 154.935 108.567 153.433L108.037 153.963L107.507 154.493C108.798 155.785 109.268 157.123 109.338 157.529L110.077 157.4ZM111.35 156.95L111.02 157.624C112.464 158.331 112.634 159.522 112.9 161.123L113.64 161L114.379 160.877C114.135 159.406 113.913 157.37 111.68 156.276L111.35 156.95ZM113.64 161C114.085 161.603 114.086 161.603 114.086 161.603C114.086 161.603 114.086 161.602 114.087 161.602C114.087 161.602 114.088 161.601 114.088 161.601C114.09 161.6 114.091 161.599 114.093 161.598C114.096 161.595 114.1 161.592 114.106 161.588C114.116 161.58 114.13 161.569 114.147 161.556C114.181 161.529 114.228 161.49 114.286 161.441C114.401 161.344 114.558 161.202 114.737 161.02C115.093 160.659 115.545 160.126 115.915 159.448C116.672 158.062 117.067 156.078 115.661 153.85L115.027 154.25L114.393 154.65C115.45 156.325 115.152 157.716 114.599 158.729C114.314 159.251 113.957 159.674 113.668 159.968C113.524 160.114 113.4 160.226 113.314 160.299C113.271 160.335 113.238 160.362 113.217 160.379C113.207 160.387 113.199 160.393 113.195 160.396C113.193 160.397 113.192 160.398 113.192 160.398C113.192 160.398 113.192 160.398 113.192 160.398C113.192 160.398 113.192 160.398 113.193 160.398C113.193 160.398 113.193 160.397 113.193 160.397C113.193 160.397 113.194 160.397 113.64 161ZM105.05 150.727L105.724 150.397C104.631 148.164 102.594 147.941 101.123 147.698L101 148.437L100.877 149.177C102.478 149.443 103.669 149.613 104.376 151.057L105.05 150.727ZM101 148.437C101.603 148.883 101.603 148.884 101.603 148.884C101.603 148.884 101.602 148.884 101.602 148.884C101.602 148.884 101.602 148.885 101.602 148.885C101.602 148.885 101.602 148.885 101.602 148.885C101.602 148.885 101.603 148.884 101.604 148.882C101.607 148.878 101.613 148.87 101.621 148.86C101.638 148.839 101.665 148.806 101.701 148.763C101.774 148.677 101.886 148.553 102.032 148.409C102.326 148.119 102.749 147.763 103.271 147.478C104.284 146.925 105.675 146.627 107.35 147.684L107.75 147.05L108.15 146.416C105.922 145.01 103.938 145.405 102.552 146.162C101.874 146.532 101.341 146.984 100.98 147.34C100.798 147.518 100.656 147.676 100.559 147.791C100.51 147.848 100.471 147.896 100.444 147.93C100.431 147.947 100.42 147.961 100.412 147.971C100.408 147.977 100.405 147.981 100.402 147.984C100.401 147.986 100.4 147.987 100.399 147.989C100.399 147.989 100.398 147.99 100.398 147.99C100.398 147.991 100.397 147.991 100.397 147.991C100.397 147.991 100.397 147.992 101 148.437ZM104.018 154.911L103.488 154.381C102.833 155.035 101.811 156.805 102.539 158.987L103.25 158.75L103.962 158.513C103.461 157.01 104.179 155.811 104.548 155.442L104.018 154.911ZM107.089 157.982L106.559 157.452C106.189 157.821 104.99 158.539 103.488 158.039L103.25 158.75L103.013 159.462C105.196 160.189 106.965 159.167 107.619 158.513L107.089 157.982ZM115.301 148.45H116.051C116.051 147.069 114.931 145.95 113.551 145.95V146.7V147.45C114.103 147.45 114.551 147.898 114.551 148.45H115.301ZM113.551 146.7V145.95C112.17 145.95 111.051 147.069 111.051 148.45H111.801H112.551C112.551 147.898 112.998 147.45 113.551 147.45V146.7ZM111.801 148.45H111.051C111.051 149.831 112.17 150.95 113.551 150.95V150.2V149.45C112.998 149.45 112.551 149.002 112.551 148.45H111.801ZM113.551 150.2V150.95C114.931 150.95 116.051 149.831 116.051 148.45H115.301H114.551C114.551 149.002 114.103 149.45 113.551 149.45V150.2Z"
					fill="#79809A"
				/>
				<circle
					cx="110"
					cy="152"
					r="19.25"
					stroke="#79809A"
					strokeWidth="1.5"
					strokeDasharray="3 3"
				/>
			</g>
			<foreignObject
				xmlSpace="preserve"
				x={0}
				y={268}
				width={220}
				height={42}
				className="overflow-visible"
			>
				<p
					className="type-body-medium w-full text-center font-body text-grey word-break-fix"
					style={{
						whiteSpace: 'pre-line',
						lineHeight: '1.4',
						margin: '0 auto',
					}}
				>
					{placeholderDescription}
				</p>
			</foreignObject>
			<defs>
				<clipPath id="clip0_32164_15789">
					<rect
						width="160"
						height="160"
						fill="white"
						transform="translate(30 72)"
					/>
				</clipPath>
			</defs>
		</svg>
	)
}
